import React from 'react';
import s from './styles/ProfilePage.module.scss';
import { useSafeErrorBanner } from 'shared/components/ErrorBanner/useSafeErrorBanner';

export const ProfilePage = () => {
  const { showErrorSafe } = useSafeErrorBanner();
  const currentUser = {
    displayName: 'Jane Doe',
    email: 'jane.doe@example.com',
    phoneNumber: '+1234567890',
    uid: 'user_123456',
    photoURL: 'https://i.pravatar.cc/150?img=12',
    emailVerified: true,
  };

  const logout = async () => {
    showErrorSafe('Logged out (mock)');
  };

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <main className={s.page}>
      <section className={s.card}>
        <h1 className={s.title}>
          Welcome, {currentUser.displayName || 'User'}!
        </h1>

        {currentUser.photoURL ? (
          <img
            src={currentUser.photoURL}
            alt="Profile"
            className={s.avatar}
          />
        ) : (
          <div className={s.avatarFallback}>?</div>
        )}

        <div className={s.info}>
          <p className={s.infoRow}>
            <span className={s.label}>Email: </span>
            {currentUser.email || 'Not provided'}
          </p>
          <p className={s.infoRow}>
            <span className={s.label}>Phone: </span>
            {currentUser.phoneNumber || 'Not provided'}
          </p>
          <p className={s.infoRow}>
            <span className={s.label}>User ID: </span>
            {currentUser.uid}
          </p>
          <p className={s.infoRow}>
            <span className={s.label}>Email Verified: </span>
            {currentUser.emailVerified ? (
              <span className={s.verifiedYes}>Yes</span>
            ) : (
              <span className={s.verifiedNo}>No</span>
            )}
          </p>
        </div>

        <button type="button" onClick={handleLogout} className={s.button}>
          Sign Out
        </button>
      </section>
    </main>
  );
};
